import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CLModal from '../../../../components/CLModal';
import CLField from '../../../../components/CLField';
import CLInput from '../../../../components/CLInput';
import CLButton from '../../../../components/CLButton';

import Icon from './icon';
import { Container, SuccessContainer } from './styled';
import { httpSendEmail } from '../../../../services/http';

const initialForm = {
  email: '',
  subject: '',
  message: '',
};

const DialogContact = ({
  websiteId,
  listing,
  isVisible,
  onClose,
}) => {
  const { t } = useTranslation();

  const [form, updateForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setSubmitted(false);
      setErrors({});
      updateForm(initialForm);
    }
  }, [isVisible]);

  const onSubmit = async () => {
    setLoading(true);

    try {
      const response = await httpSendEmail({
        website_id: websiteId,
        listing_id: listing.listing_id,
        params: {
          ...form,
        },
      });

      setLoading(false);

      if (response.status === 202) {
        setSubmitted(true);
      }
    } catch (e) {
      setErrors(e.response.data);
      setLoading(false);
    }
  };

  const onChangeForm = (value, fieldCode) => {
    updateForm((prev) => ({
      ...prev,
      [fieldCode]: value,
    }));

    setErrors((errors) => {
      const newErrors = { ...errors };
      delete newErrors[fieldCode];

      return newErrors;
    });
  };

  const renderContent = () => {
    if (submitted) {
      return (
        <>
          <SuccessContainer>
            <Icon />
            <h3>
              {t('message_sent', 'Message Sent')}
              !
            </h3>
            <p>
              {t('get_back_soon', 'We will get back to you as soon as possible')}
              .
            </p>
          </SuccessContainer>
        </>
      );
    }

    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <CLField
          label={t('email', 'Email')}
          error={errors.email}
          field={() => <CLInput value={form.email} onChange={(value) => onChangeForm(value, 'email')} />}
        />

        <CLField
          label={t('subject', 'Subject')}
          error={errors.subject}
          field={() => <CLInput value={form.subject} onChange={(value) => onChangeForm(value, 'subject')} />}
        />

        <CLField
          label={t('message', 'Message')}
          error={errors.message}
          field={() => <CLInput multiline value={form.message} onChange={(value) => onChangeForm(value, 'message')} />}
        />

        <input style={{ display: 'none' }} type="submit" />
      </form>
    );
  };

  const renderFooter = () => {
    if (submitted) {
      return (
        <>
          <CLButton primary onClick={onClose}>{t('close', 'Close')}</CLButton>
        </>
      );
    }

    return (
      <>
        <CLButton onClick={onClose}>{t('cancel', 'Cancel')}</CLButton>
        <CLButton
          type="submit"
          onClick={onSubmit}
          primary
          loading={loading}
        >
          {t('send_message', 'Send Message')}
        </CLButton>
      </>
    );
  };

  return (
    <CLModal
      isVisible={isVisible}
      onClose={onClose}
      title={t('contact_property_manager', 'Contact Property Manager')}
      renderContent={renderContent}
      renderFooter={renderFooter}
    >
      <Container />
    </CLModal>
  );
};

DialogContact.propTypes = {
  websiteId: PropTypes.string.isRequired,
  listing: PropTypes.object.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DialogContact;
